import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsIn, IsInstance, IsNotEmpty, IsNumber, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderBundleElementSubtypeEnum, OrderElementTypeEnum, OrderStoreItemElementSubTypeEnum } from '../enum';
import { OrderExposeGroup } from '../interface';
import { PatchOrderElementMetadataDto } from './PatchOrderElementMetadataDto';
import { PatchOrderItemDto } from './PatchOrderItemDto';
import { PatchOrderPropertyDto } from './PatchOrderPropertyDto';
import { PatchOrderWeightDto } from './PatchOrderWeightDto';
export class PatchBaseOrderStoreItemElementDto extends PatchOrderItemDto {
}
__decorate([
    ApiPropertyOptional({ enum: OrderElementTypeEnum, example: OrderElementTypeEnum.ELEMENT }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsIn([OrderElementTypeEnum.ELEMENT, OrderElementTypeEnum.BUNDLE_ITEM, OrderElementTypeEnum.COMBO], { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchBaseOrderStoreItemElementDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ enum: OrderStoreItemElementSubTypeEnum, example: OrderStoreItemElementSubTypeEnum.PACKING_INSTRUCTIONS }),
    IsUndefinable({ always: true }),
    IsIn([OrderStoreItemElementSubTypeEnum.PACKING_INSTRUCTIONS, ...Object.values(OrderBundleElementSubtypeEnum)], { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchBaseOrderStoreItemElementDto.prototype, "subtype", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 0.25 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchBaseOrderStoreItemElementDto.prototype, "basePrice", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderWeightDto }),
    Type(() => PatchOrderWeightDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderWeightDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderWeightDto)
], PatchBaseOrderStoreItemElementDto.prototype, "weight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 1 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchBaseOrderStoreItemElementDto.prototype, "delayTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 1 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchBaseOrderStoreItemElementDto.prototype, "printOrder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], PatchBaseOrderStoreItemElementDto.prototype, "containsAlcohol", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'QA Mango Margarita' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchBaseOrderStoreItemElementDto.prototype, "titleOriginal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 10 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchBaseOrderStoreItemElementDto.prototype, "maxQuantity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 1 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchBaseOrderStoreItemElementDto.prototype, "minQuantity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderPropertyDto, isArray: true }),
    Type(() => PatchOrderPropertyDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsInstance(PatchOrderPropertyDto, { always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], PatchBaseOrderStoreItemElementDto.prototype, "properties", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true, example: ['32787099-1b6c-4de1-b7c1-748f9cbe72ce', 'cfdcb7cd-1185-4bcb-977a-75584fb079e1'] }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], PatchBaseOrderStoreItemElementDto.prototype, "categoryUids", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'https://*.png' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchBaseOrderStoreItemElementDto.prototype, "image_url", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'https://*.png' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchBaseOrderStoreItemElementDto.prototype, "image_url_square", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 0.5 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchBaseOrderStoreItemElementDto.prototype, "tax_percentage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderElementMetadataDto }),
    Type(() => PatchOrderElementMetadataDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderElementMetadataDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderElementMetadataDto)
], PatchBaseOrderStoreItemElementDto.prototype, "metadata", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: '0fbc5d94-c2f5-479c-a872-8c0a52d99de7' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchBaseOrderStoreItemElementDto.prototype, "uniqueNameOriginal", void 0);
//# sourceMappingURL=PatchBaseOrderStoreItemElementDto.js.map